import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import DropdownList from 'components/controls/DropdownList';
import FileUpload from '../../components/controls/FileUpload';
import xls from '../../assets/template/BankTxnFileTemplate.xlsx';

let stateNames = [
    {
        "Id": 0,
        "Name": "Andaman and Nicobar Islands"
    },
    {
        "Id": 1,
        "Name": "Andhra Pradesh"
    },
    {
        "Id": 3,
        "Name": "Arunachal Pradesh"
    },
    {
        "Id": 4,
        "Name": "Assam"
    },
    {
        "Id": 5,
        "Name": "Bihar"
    },
    {
        "Id": 6,
        "Name": "Chandigarh"
    },
    {
        "Id": 7,
        "Name": "Chhattisgarh"
    },
    {
        "Id": 8,
        "Name": "Dadra and Nagar Haveli"
    },
    {
        "Id": 9,
        "Name": "Daman and Diu"
    },
    {
        "Id": 10,
        "Name": "Delhi"
    },
    {
        "Id": 11,
        "Name": "Goa"
    },
    {
        "Id": 12,
        "Name": "Gujarat"
    },
    {
        "Id": 13,
        "Name": "Haryana"
    },
    {
        "Id": 14,
        "Name": "Himachal Pradesh"
    },
    {
        "Id": 15,
        "Name": "Jammu and Kashmir"
    },
    {
        "Id": 16,
        "Name": "Jharkhand"
    },
    {
        "Id": 17,
        "Name": "Karnataka"
    },
    {
        "Id": 18,
        "Name": "Kerala"
    },
    {
        "Id": 19,
        "Name": "Lakshadweep"
    },
    {
        "Id": 20,
        "Name": "Madhya Pradesh"
    },
    {
        "Id": 21,
        "Name": "Maharashtra"
    },
    {
        "Id": 22,
        "Name": "Manipur"
    },
    {
        "Id": 23,
        "Name": "Meghalaya"
    },
    {
        "Id": 24,
        "Name": "Mizoram"
    },
    {
        "Id": 25,
        "Name": "Nagaland"
    },
    {
        "Id": 26,
        "Name": "Odisha"
    },
    {
        "Id": 27,
        "Name": "Puducherry"
    },
    {
        "Id": 28,
        "Name": "Punjab"
    },
    {
        "Id": 29,
        "Name": "Rajasthan"
    },
    {
        "Id": 30,
        "Name": "Sikkim"
    },
    {
        "Id": 31,
        "Name": "Tamil Nadu"
    },
    {
        "Id": 32,
        "Name": "Telangana"
    },
    {
        "Id": 33,
        "Name": "Tripura"
    },
    {
        "Id": 34,
        "Name": "Uttar Pradesh"
    },
    {
        "Id": 35,
        "Name": "Uttarakhand"
    },
    {
        "Id": 36,
        "Name": "West Bengal"
    }
]

class ExportCandidates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            postId: 0,
            categoryId: 0,
            state: "",
            district: "",
            taluka: "",
            exams: [],
            category: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.getAllExams();
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();
                    let categoryList = await _AdminService.GetAllCategory();

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        category: categoryList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleDownload = async (input) => {
        //console.log("reached: ", this.state);

        try {
            if(!this.state.postId){
                _notification.showMessage('error', "Please select Post to download candidates list.");
                return;
            }

            this.setState({ loading: true }, async () => {
                try {
                    //AppliedPostId, CategoryId, State, District, Taluka, Name

                    const params = {
                        AppliedPostId: this.state.postId,
                        CategoryId: this.state.categoryId,
                        State: this.state.state,
                        District: this.state.district.trim(),
                        Taluka: this.state.taluka.trim(),
                        Name: this.state.name.trim()
                    }

                    const response = await _AdminService.ExportAllStudentData(...Object.values(params));
                    //console.log("File response: ", response.data);
                    
                    if (response.status == 200 && response.data.length > 0) {
                        //console.log('Final URL: ', _AdminService.GetAllStudentURL(response.data));

                        let alink = document.createElement('a');
                        alink.href = _AdminService.GetAllStudentURL(response.data);
                        alink.download = response.data;
                        alink.click();

                        //_notification.showMessage('success', "File uploaded successfully.");
                        this.setState({
                            loading: false,
                            // name: "",
                            // postId: 0,
                            // categoryId: 0,
                            // state: 0,
                            // district: "",
                            // taluka: "",
                        });
                    }
                    else {
                        this.setState({ loading: false });
                        _notification.showMessage('error', "No records found");
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    onTextChange = (event) => {
        //console.log([event.target.name], ' = = ', event.target.value);
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
        });
    }

    onPostChange = (event) => {
        this.setState({
            ...this.state,
            postId: event.target.value
        });
    }

    onCategoryChange = (event) => {
        this.setState({
            ...this.state,
            categoryId: event.target.value
        });
    }

    onStateChange = (event) => {
        let stateName = this.getStateName(event.target.value);
        this.setState({
            ...this.state,
            state: stateName
        });
    }

    getStateName(stateId) {
        if (stateId) {
            var item = stateNames.find(item => item.Id == stateId);
            return item ? item.Name : "";
        }
        return "";
    }

    getStateID(stateName) {
        if (stateName) {
            var item = stateNames.find(item => item.Name == stateName);
            return item ? item.Id : -1;
        }
        return -1;
    }


    render() {

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <div className="max1200 m-auto">
                    <PageHeader
                        title="Export Candidates"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Reports' }, { label: 'Export Candidates' }]}
                    />
                    <div className="ent-panel mb-4">
                        <div className="admin-inner-wrap p-3">
                            <div className="row flex-sm-row ">
                                <div className="mb-2 col-sm-4">
                                    <label htmlFor="password">Name</label>
                                    <MyInput id="name"
                                        type="text"
                                        key="name"
                                        name="name"
                                        value={this.state.name}
                                        onChange={this.onTextChange}
                                        isRequired={true}
                                    // errorState={this.state.postError}
                                    // errorMessage={this.state.postError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.state.postId}
                                        name="ParentId"
                                        onChange={this.onPostChange}
                                        placeholder="Select Post"
                                        heading={"Post/Exam"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={this.state.exams}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.state.categoryId}
                                        name="ParentId"
                                        onChange={this.onCategoryChange}
                                        placeholder="Select Category"
                                        heading={"Category"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={false}
                                        options={this.state.category}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                            </div>
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.getStateID(this.state.state)}
                                        name="ParentId"
                                        onChange={this.onStateChange}
                                        placeholder="Select State"
                                        heading={"State"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={false}
                                        options={stateNames}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                                <div className="mb-2 col-sm-4">
                                    <label htmlFor="password">District</label>
                                    <MyInput id="district"
                                        type="text"
                                        key="district"
                                        name="district"
                                        value={this.state.district}
                                        onChange={this.onTextChange}
                                        isRequired={true}
                                    // errorState={this.state.postError}
                                    // errorMessage={this.state.postError} 
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <label htmlFor="password">Taluka</label>
                                    <MyInput id="taluka"
                                        type="text"
                                        key="taluka"
                                        name="taluka"
                                        value={this.state.taluka}
                                        onChange={this.onTextChange}
                                        isRequired={true}
                                    // errorState={this.state.postError}
                                    // errorMessage={this.state.postError} 
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <button type="button" onClick={this.handleDownload} className="button-global button-primary autoHeight small"><span>Export</span></button>
                        </div>
                    </div>
                </div> 
            </div>
        )
    };
}

export default ExportCandidates;